module.exports = __webpack_public_path__ + "img/ekyc-ibank-guide-04.09950f33.png";